import { ColDef } from 'ag-grid-community';
import { Component, OnInit, ViewChild } from '@angular/core';
import { AfterContentChecked } from 'cv-ng-metadata/core';
import { AddEntityComponent, Entity, Filter } from '@niceltd/cxone-domain-components/add-entity';
import { cloneDeep } from 'lodash';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { filter } from 'rxjs';
import { GroupTypeDTO } from 'src/AngularJS/Admin/Company/company.model';
import { BaseGroupType } from 'src/AngularJS/Models/group-type.model';
import { AngularAssignToolService } from 'src/app/reusables/assign-tool/angular-assign-tool.service';
import { cvAssignmentToolGroupItem, GroupDTO } from 'src/app/reusables/assign-tool/angular-assign-tool/angular-assign-tool.models';
import { AgentAttributeValueDTO, CvCxAssignToolDTO, CvCxAssignToolOptions, CvCxEntity, CvCxEntityType, LoginDTO } from 'src/app/reusables/assign-tool/cv-cxone-assign-tool/cv-cxone-assign-tool.models';
import { CVLocalizationService } from 'src/app/reusables/services/cv-localization.service';

@Component({
    selector: 'cv-cxone-assign-tool',
    templateUrl: './cv-cxone-assign-tool.component.html',
    styleUrls: ['./cv-cxone-assign-tool.component.scss']
})
export class CvCxoneAssignToolComponent implements OnInit, AfterContentChecked {
    public options: CvCxAssignToolOptions = null;
    public entity: Entity;
    public loading = true;
    public isSingleAssignValid: boolean = true;
    public saveDisabled = true;

    @ViewChild("cxAddEntity", { static: false }) entityComponent: AddEntityComponent;

    private localization: Map<string, string>;
    private entityTypes: CvCxEntityType[] = [];
    private entityList: CvCxEntity[] = [];
    private initialAssignment: CvCxEntity[] = [];
    private multipleTypes: boolean = false;
    private applyInitialFilter: boolean = true;
    private readonly LoginBaseGroupLevel: number = -1;
    scrollPosition: number = 0;
    gridContainer: HTMLElement = null;
    scrollContainer: HTMLElement = null;
    initialFilterToggleComplete: boolean = false;

    constructor(private service: AngularAssignToolService, private modalRef: DynamicDialogRef, private modalConf: DynamicDialogConfig,
        private locService: CVLocalizationService) { }

    ngAfterContentChecked() {
        if (this.applyInitialFilter && this.entityComponent?.gridApi != undefined) {
            this.applyInitialFilter = false;
            this.entityComponent.applyFilter();
            this.setInitialFilter();
        }
        if (this.gridContainer) {
            this.scrollContainer.style.overflow = 'hidden';
            this.restoreScrollPosition(this.gridContainer, true);
        }

        if (this.options?.showFilter && this.entityComponent?.gridApi != undefined && !this.initialFilterToggleComplete) {
            this.entityComponent.toggleFilters()
            this.initialFilterToggleComplete = true;
        }

        //Disable Save button if there are no changes (if the remove and selecteds lists are empty)
        if (this.options.showTypeValues.emp == true) {
            if (this.entityComponent?.removedEntities?.filter(e => e.baseGroupType == BaseGroupType.Employee).map<GroupDTO>(e => e.DTO).length ||
                this.entityComponent?.selectedEntities?.filter(e => e.baseGroupType == BaseGroupType.Employee).map<GroupDTO>(e => e.DTO).length) {
                this.saveDisabled = false;
            } else if (!this.entityComponent?.addedEntities?.filter(e => e.baseGroupType == BaseGroupType.Employee).map<GroupDTO>(e => e.DTO).length && this.initialAssignment?.length) {
                this.saveDisabled = false;
            } else {
                this.saveDisabled = true;
            }
        }

        if (this.options.showTypeValues.rec == true) {
            if (this.entityComponent?.removedEntities?.filter(e => e.baseGroupType == BaseGroupType.Recording).map<GroupDTO>(e => e.DTO).length ||
                this.entityComponent?.selectedEntities?.filter(e => e.baseGroupType == BaseGroupType.Recording).map<GroupDTO>(e => e.DTO).length) {
                this.saveDisabled = false;
            } else if (!this.entityComponent?.addedEntities?.filter(e => e.baseGroupType == BaseGroupType.Recording).map<GroupDTO>(e => e.DTO).length && this.initialAssignment?.length) {
                this.saveDisabled = false;
            } else {
                this.saveDisabled = true;
            }
        }
    }

    async ngOnInit() {
        if (!this.modalConf?.data?.options)
            return;

        this.options = this.modalConf.data.options;

        this.multipleTypes = Object.values(this.options.showTypeValues).filter(e => e === true).length > 1;

        this.localization = await this.locService.GetSection("Assign_Tool");

        await this.loadEntityTypes();
        await this.loadEntityList();
        this.loadAssignedEntities();
        this.entity = this.createEntity();
        this.loading = false;
    }

    public save() {
        // If using bulk operations filter out any duplicates
        if (this.options.useBulkAdd)
            this.entityComponent.selectedEntities = this.entityComponent.selectedEntities.filter((v, i, ar) => ar.findIndex((v2) => {
                return v2.baseGroupType == v.baseGroupType && v2.entityLevel == v.entityLevel && v2.entityName == v.entityName;
            }) == i);

        let data: CvCxAssignToolDTO = {
            assigned: {
                emp: this.entityComponent.addedEntities.filter(e => e.baseGroupType == BaseGroupType.Employee).map<GroupDTO>(e => e.DTO),
                rec: this.entityComponent.addedEntities.filter(e => e.baseGroupType == BaseGroupType.Recording).map<GroupDTO>(e => e.DTO),
                agentAttribute: this.entityComponent.addedEntities.filter(e => e.baseGroupType == BaseGroupType.UserAttribute).
                    map<AgentAttributeValueDTO>(e => e.DTO),
                login: this.entityComponent.addedEntities.filter(e => e.baseGroupType == -1).map<LoginDTO>(e => e.DTO),
            },
            selected: {
                emp: this.entityComponent.selectedEntities.filter(e => e.baseGroupType == BaseGroupType.Employee).map<GroupDTO>(e => e.DTO),
                rec: this.entityComponent.selectedEntities.filter(e => e.baseGroupType == BaseGroupType.Recording).map<GroupDTO>(e => e.DTO),
                agentAttribute: this.entityComponent.selectedEntities.filter(e => e.baseGroupType == BaseGroupType.UserAttribute).
                    map<AgentAttributeValueDTO>(e => e.DTO),
                login: this.entityComponent.selectedEntities.filter(e => e.baseGroupType == -1).map<LoginDTO>(e => e.DTO),
            },
            removed: {
                emp: this.entityComponent.removedEntities.filter(e => e.baseGroupType == BaseGroupType.Employee).map<GroupDTO>(e => e.DTO),
                rec: this.entityComponent.removedEntities.filter(e => e.baseGroupType == BaseGroupType.Recording).map<GroupDTO>(e => e.DTO),
                agentAttribute: this.entityComponent.removedEntities.filter(e => e.baseGroupType == BaseGroupType.UserAttribute).
                    map<AgentAttributeValueDTO>(e => e.DTO),
                login: this.entityComponent.removedEntities.filter(e => e.baseGroupType == -1).map<LoginDTO>(e => e.DTO),
            },
        };

        this.modalRef.close(data);
    }

    public close() {
        this.modalRef.close(null);
    }

    private async loadEntityTypes() {
        const data = await this.service.loadGroupTypes();

        if (this.options.showTypeValues.emp) {
            let empTypes = data.EmpGroupTypes.map<CvCxEntityType>(this.mapGroupTypeDtoToEntityType.bind(this));
            if (this.options?.maxEmpLevel != undefined)
                empTypes = empTypes.filter(f => f.entityLevel <= this.options.maxEmpLevel);
            if (this.options?.minEmpLevel != undefined)
                empTypes = empTypes.filter(f => f.entityLevel >= this.options.minEmpLevel);
            if (this.options?.singleEmpLevel != undefined)
                empTypes = empTypes.filter(f => f.entityLevel == this.options.singleEmpLevel);
            this.entityTypes.push(...empTypes);
        }

        if (this.options.showTypeValues.rec) {
            let recTypes = data.RecGroupTypes.map<CvCxEntityType>(this.mapGroupTypeDtoToEntityType.bind(this));
            if (this.options?.maxRecLevel != undefined)
                recTypes = recTypes.filter(f => f.entityLevel <= this.options.maxRecLevel);
            if (this.options?.minRecLevel != undefined)
                recTypes = recTypes.filter(f => f.entityLevel >= this.options.minRecLevel);
            if (this.options?.singleRecLevel != undefined)
                recTypes = recTypes.filter(f => f.entityLevel == this.options.singleRecLevel);
            this.entityTypes.push(...recTypes);
        }

        if (this.options.showTypeValues.agent_att) {
            this.entityTypes.push(...(((await this.service.loadAttributes()) as any[])
                .map<CvCxEntityType>(this.mapAgentAttributeToEntityType.bind(this))));
        }

        if (this.options.showTypeValues.logins)
            this.entityTypes.push({
                companyId: 0,
                assignable: true,
                baseGroupType: this.LoginBaseGroupLevel,
                entityLevel: 0,
                entityTypeName: this.localization.get("Logins") ?? "Logins",
            });
    }

    private async loadEntityList() {
        let promises: Promise<any>[] = [];

        // Load Emp/Rec Groups, Agent Attributes and Logins
        this.entityTypes.forEach(gt => {
            let promise: Promise<any> = null;

            if (gt.baseGroupType == BaseGroupType.Employee && this.options.showTypeValues.emp)
                promise = this.service.loadEmpGroups(gt.entityLevel);

            else if (gt.baseGroupType == BaseGroupType.Recording && this.options.showTypeValues.rec)
                promise = this.service.loadRecGroups(gt.entityLevel);

            else if (gt.baseGroupType == BaseGroupType.UserAttribute && this.options.showTypeValues.agent_att)
                promise = this.service.loadAttributeValues(gt.entityLevel);

            else if (gt.baseGroupType == this.LoginBaseGroupLevel && this.options.showTypeValues.logins) {
                let level = this.options.loginDataOptions?.groupLevel ?? null;
                let type = this.options.loginDataOptions?.groupType ?? null;
                let groupId = this.options.loginDataOptions?.groupId ?? null;
                let profileId = this.options.loginDataOptions?.profileId ?? null;

                if (this.options.loginDataOptions?.loadByParentGroup == true)
                    promise = this.service.loadLoginsByParentGroup(level, type, groupId);
                else
                    promise = this.service.loadLogins(level, type, groupId, profileId);
            }

            if (promise != null)
                promises.push(promise.then((value) => {
                    return { GroupType: gt.baseGroupType, Value: value };
                }, (reason) => []));
        });

        (await Promise.all(promises)).forEach(lst => {
            let mappedData;

            if (lst.GroupType == BaseGroupType.Employee || lst.GroupType == BaseGroupType.Recording)
                mappedData = (lst.Value as cvAssignmentToolGroupItem[])?.filter(dto => dto.groupDTO?.Active)
                    ?.map<CvCxEntity>(this.mapGroupItemToEntity.bind(this)) ?? [];

            else if (lst.GroupType == BaseGroupType.UserAttribute)
                mappedData = (lst.Value as AgentAttributeValueDTO[])?.filter(e => e.Active)
                    ?.map<CvCxEntity>(this.mapAgentAttributeToEntity.bind(this)) ?? [];

            else if (lst.GroupType == this.LoginBaseGroupLevel)
                mappedData = (lst.Value as LoginDTO[])?.filter(e => e.Active)?.map<CvCxEntity>(this.mapLoginToEntity.bind(this)) ?? [];

            this.entityList.push(...mappedData);
        });

    }

    private loadAssignedEntities() {
        let assignedEntities: CvCxEntity[] = [];

        // Map inputs to CvCxGroup
        assignedEntities.push(...(this.options?.assignedEntities?.emp?.map<CvCxEntity>(this.mapGroupDtoToEntity.bind(this)) ?? []));
        assignedEntities.push(...(this.options?.assignedEntities?.rec?.map<CvCxEntity>(this.mapGroupDtoToEntity.bind(this)) ?? []));
        assignedEntities.push(...(this.options?.assignedEntities?.agentAttribute?.map<CvCxEntity>(this.mapAgentAttributeToEntity.bind(this)) ?? []));
        assignedEntities.push(...(this.options?.assignedEntities?.login?.map<CvCxEntity>(this.mapLoginToEntity.bind(this)) ?? []));

        // Remove already assigned 
        for (let i = 0; i < assignedEntities.length; ++i) {
            let assigned = assignedEntities[i];
            let index = this.entityList.findIndex(e => e.baseGroupType == assigned.baseGroupType && e.entityLevel == assigned.entityLevel && e.entityName == assigned.entityName);
            if (index > -1)
                assigned[i] = this.entityList.splice(index, 1)[0];
        }

        this.initialAssignment = assignedEntities;
    }

    private setInitialFilter() {
        // If there are already assigned, have the filter display the remainder of those types
        if (this.initialAssignment.length > 0) {
            let initial = this.initialAssignment[0];
            this.setFilter(initial.baseGroupType, initial.entityLevel, initial.entityLevelName);
        }
        else if (this.options.initialFilter)
            this.setFilter(this.options.initialFilter.baseGroupType, this.options.initialFilter.entityLevel,
                this.options.initialFilter.entityLevelName);
    }

    private setFilter(baseGroupType: BaseGroupType, entityLevel: number, entityLevelName: string) {
        let initialFilter = {
            level: [{
                id: `${baseGroupType}_${entityLevel}`,
                level: entityLevel,
                name: entityLevelName,
                selected: true
            }]
        }

        this.entityComponent.filterOptionsChosen = initialFilter;
        this.entityComponent.applyFilter();
    }

    private mapGroupTypeDtoToEntityType(groupTypeDTO: GroupTypeDTO) {
        return {
            companyId: groupTypeDTO.CompanyID,
            entityTypeName: groupTypeDTO.GroupTypeName,
            baseGroupType: groupTypeDTO.BaseGroupType,
            entityLevel: groupTypeDTO.GroupLevel,
            assignable: groupTypeDTO.Assignable,
        };
    }

    private mapAgentAttributeToEntityType(agentAttribute: any) {
        return {
            companyId: agentAttribute.CompanyID,
            entityTypeName: agentAttribute.AttributeName,
            baseGroupType: BaseGroupType.UserAttribute,
            entityLevel: agentAttribute.AgentAttributeID,
            assignable: agentAttribute.Active,
        };
    }

    private mapGroupItemToEntity(groupItem: cvAssignmentToolGroupItem): CvCxEntity {
        return this.mapGroupDtoToEntity(groupItem.groupDTO, groupItem.parentPath);
    }

    private mapGroupDtoToEntity(groupDTO: GroupDTO, parentData?: string[]) {
        let entity: CvCxEntity = {
            entityLevel: groupDTO.GroupLevel,
            entityLevelName: "",
            entityName: groupDTO.GroupName,
            baseGroupType: groupDTO.BaseGroupType,
            DTO: groupDTO,
        };

        entity.entityLevelName = this.entityTypes.find(e => (e.baseGroupType == entity.baseGroupType
            && e.entityLevel == groupDTO.GroupLevel))?.entityTypeName ?? "";

        if (entity.baseGroupType == BaseGroupType.Employee || entity.baseGroupType == BaseGroupType.Recording) {
            entity.parentName = (parentData?.length > 0) ? parentData[parentData.length - 1] : "";
            entity.grandParentName = (parentData?.length > 1) ? parentData[parentData.length - 2] : "";
        }

        return entity;
    }

    private mapAgentAttributeToEntity(attribute: AgentAttributeValueDTO): CvCxEntity {
        let entity: CvCxEntity = {
            entityLevel: attribute.AgentAttributeID,
            entityLevelName: "",
            entityName: attribute.AttributeValueName,
            baseGroupType: BaseGroupType.UserAttribute,
            DTO: attribute,
        };

        entity.entityLevelName = this.entityTypes.find(gt => gt.baseGroupType == BaseGroupType.UserAttribute
            && gt.entityLevel == entity.entityLevel)?.entityTypeName ?? "";

        return entity;
    }

    private mapLoginToEntity(login: LoginDTO): CvCxEntity {
        let entity: CvCxEntity = {
            entityLevel: login.LoginID,
            entityLevelName: `${this.localization.get("Logins") ?? "Logins"}`,
            entityName: login.LoginName,
            baseGroupType: this.LoginBaseGroupLevel,
            DTO: login,
        };

        return entity;
    }

    private onFilterChange(items: any[], filterOptions: any): any[] {
        this.gridContainer = document.querySelector('.cxone-modal-wrapper .ag-body-viewport') as HTMLElement;
        this.scrollContainer = document.querySelector('.cxone-modal-wrapper .ag-body-vertical-scroll-viewport') as HTMLElement;
        if (this.gridContainer) {
            this.saveScrollPosition(this.gridContainer);
        }

        this.entity.filters = this.createFilters(filterOptions);
        this.entity.columnDefs = this.createColumnDefs(filterOptions);

        // Fix any items that were Assigned but aren't anymore..
        let unassigned: number[] = [];
        items.forEach((e, i) => {
            if (e.entityLevel < 4 && !Object.keys(e).includes("parentName"))
                unassigned.push(i);
        });
        if (unassigned.length > 0) {
            for (let i = unassigned.length - 1; i > -1; --i) {
                let temp: CvCxEntity = items[unassigned[i]];
                items.splice(unassigned[i], 1);
                switch (temp.baseGroupType) {
                    case BaseGroupType.Employee:
                    case BaseGroupType.Recording:
                        temp = this.mapGroupDtoToEntity(temp.DTO as GroupDTO, items[unassigned[i - 1]].parentData);
                        break;
                    case BaseGroupType.UserAttribute:
                        temp = this.mapAgentAttributeToEntity(temp.DTO as AgentAttributeValueDTO);
                        break;
                    case this.LoginBaseGroupLevel:
                        temp = this.mapLoginToEntity(temp.DTO as LoginDTO);
                        break;
                }
                items.push(temp);
            }
        }

        // If Bulk Add we need to manually remove duplicate entities on deselection
        if (this.options?.useBulkAdd)
            items = items.filter((e, i, ar) => ar.findIndex(e2 => e.baseGroupType == e2.baseGroupType
                && e.entityLevel == e2.entityLevel && e.entityName == e2.entityName) == i);

        if (filterOptions?.level.length > 0) {
            let split = (filterOptions.level[0].id as string).split('_');
            switch (split[1]) {
                case '1':
                    if (split[0] == '1')
                        this.entity.omnibar.searchPlaceholderText = this.localization?.get("Search_POC") ?? "Search point of contact";
                    break;
                case '2':
                    if (split[0] == '1')
                        this.entity.omnibar.searchPlaceholderText = this.localization?.get("Search_Skill") ?? "Search skill";
                    break;
                case '3':
                    if (split[0] == '1')
                        this.entity.omnibar.searchPlaceholderText = this.localization?.get("Search_Campaign") ?? "Search campaign";
                    break;
                case '4':
                    if (split[0] == '1')
                        this.entity.omnibar.searchPlaceholderText = this.localization?.get("Search_Company") ?? "Search company";
                    break;
            }
        }

        if (this.multipleTypes) {
            let tempLevelFilter = cloneDeep(filterOptions.level) ?? [];

            let baseGroups: number[] = [];

            if (filterOptions.groups.length > 0) {
                filterOptions.groups.forEach(g => {
                    switch (g.id) {
                        case "emp":
                            baseGroups.push(BaseGroupType.Employee);
                            break;
                        case "rec":
                            baseGroups.push(BaseGroupType.Recording);
                            break;
                        case "agent_att":
                            baseGroups.push(BaseGroupType.UserAttribute);
                            break;
                        case "logins":
                            baseGroups.push(this.LoginBaseGroupLevel);
                            break;
                    }
                });

                // Filter by Base Type
                items = (items as CvCxEntity[]).filter(e => baseGroups.findIndex(b => b == e.baseGroupType) > -1);
            }

            // Clear invalid filter selections
            filterOptions.level = (tempLevelFilter as any[])?.filter(e => {
                let baseType = Number.parseInt(e.id.split('_')[0]) ?? -5;
                return (baseGroups.findIndex(e => e == baseType) > -1)
            });
            this.entityComponent.filterOptionsChosen.level = filterOptions.level;
        }

        if ((this.entityComponent.selectedEntities.length + this.entityComponent.addedEntities.length) > 0)
            if (this.options.singleAdd)
                return [];
            else if (this.options.singleType) {
                let groupType: BaseGroupType = (this.entityComponent.addedEntities.length > 0)
                    ? this.entityComponent.addedEntities[0].baseGroupType : this.entityComponent.selectedEntities[0].baseGroupType;
                items = (items as CvCxEntity[]).filter(e => e.baseGroupType == groupType);
            }

        let groupLevels: Map<number, number[]> = new Map();
        (filterOptions?.level as any[]).forEach(e => {
            if (!e?.selected)
                return;
            let splitId: string[] = (e.id as string).split('_');
            let groupType: number = Number.parseInt(splitId[0]);
            let groupLevel: number = Number.parseInt(splitId[1]);
            if (groupLevels.has(groupType)) {
                let arr = groupLevels.get(groupType);
                if (arr.findIndex(e => e == groupLevel) == -1)
                    arr.push(groupLevel);
            }
            else
                groupLevels.set(groupType, [groupLevel]);
        });

        items = (items as CvCxEntity[]).filter(e => {
            // On deselecting an assigned entity it's baseGroupType is a string..
            let baseGroupType = Number.parseInt(e.baseGroupType as any);

            if (baseGroupType == -1 && ((this.multipleTypes && filterOptions.groups.findIndex(i => i.id == "logins") > -1) || (!this.multipleTypes && this.options.showTypeValues.logins)))
                return true;

            if (groupLevels.has(baseGroupType))
                return groupLevels.get(baseGroupType).findIndex(l => l == e.entityLevel) > -1;
            return false;
        });

        if (this.options.singleLevel) {
            let entity: CvCxEntity = this.entityComponent.selectedEntities[0] ?? this.entityComponent.addedEntities[0] ?? null;
            if (!!entity)
                items = items.filter(f => f.entityLevel == entity.entityLevel);
        }
        // trigger single assign validation
        this.isSingleAssignValid = this.singleAssignValidation();

        return this.options.onFilterChanged?.(items, filterOptions) ?? items;
    }

    private createFilters(filterOptions: any = null): Filter[] {
        let filters: Filter[] = [];
        if (this.multipleTypes)
            filters.push({
                id: "groups",
                label: this.localization?.get("Groups") ?? "Groups",
                placeholder: this.localization?.get("groups") ?? "Select groups",
                items: this.getGroupFilterItems(filterOptions),
                sortKey: "level",
                sortOrder: "desc",
                maxSelectionLimit: 1,
                searchable: false,
                onSearch: undefined,
                populateData: undefined,
            });

        if (!filterOptions || ((this.multipleTypes && filterOptions.groups.findIndex(i => i.id == "logins") == -1) || (!this.multipleTypes && !this.options.showTypeValues.logins))) {
            let label = this.localization?.get("Level") ?? "";
            let placeholder = this.localization?.get("Select_Level") ?? "Select level";

            if (!this.multipleTypes) {
                if (this.options.showTypeValues.emp) {
                    label = this.localization?.get("Employee_Group") || "EMPLOYEE GROUP";
                    placeholder = this.localization?.get("Select_Employee") || "Select employee group";
                }
                else if (this.options.showTypeValues.rec) {
                    label = this.localization?.get("Contact_Group") || "CONTACT GROUP";
                    placeholder = this.localization?.get("Select_Rec") || "Select contact group";
                }
                else if (this.options.showTypeValues.agent_att) {
                    label = this.localization?.get("Attribute") || "ATTRIBUTE";
                    placeholder = this.localization?.get("Select_Attribute") || "Select attribute";
                }
            }

            filters.push({
                id: "level",
                label: label,
                placeholder: placeholder,
                items: this.getLevelFilterItems(filterOptions),
                sortKey: "level",
                sortOrder: "desc",
                maxSelectionLimit: 1,
                searchable: false,
                onSearch: undefined,
                populateData: undefined,
            });
        }

        return filters;
    }

    private getGroupFilterItems(filterOptions: any = null) {
        let groupItems = Object.keys(this.options.showTypeValues).filter(e => this.options.showTypeValues[e] === true)
            .map<{ id: string, name: string }>(e => {
                switch (e) {
                    case "emp":
                        return { id: e, level: "1", name: this.localization.get("Employees") ?? "Employees" };
                    case "rec":
                        return { id: e, level: "2", name: this.localization.get("Contacts") ?? "Contacts" };
                    case "agent_att":
                        return { id: e, level: "3", name: this.localization.get("Attributes") ?? "Attributes" };
                    case "logins":
                        return { id: e, level: "4", name: this.localization.get("Logins") ?? "Logins" };
                }
            });

        // If item is selected filter out unselected to prevent multi-select
        //if ((filterOptions?.groups?.length ?? 0) == 1)
        //    groupItems = groupItems.filter(e => filterOptions.groups[0].id == e.id);

        return groupItems;
    }

    private getLevelFilterItems(filterOptions: any = null) {
        let entityTypes = this.entityTypes.filter(e => e.assignable && e.baseGroupType > this.LoginBaseGroupLevel);

        let baseFilter: number[] = [];
        if (filterOptions != null && this.multipleTypes && filterOptions?.groups?.length > 0) {
            filterOptions.groups.forEach(f => {
                switch (f.id) {
                    case "emp":
                        baseFilter.push(BaseGroupType.Employee);
                        break;
                    case "rec":
                        baseFilter.push(BaseGroupType.Recording);
                        break;
                    case "agent_att":
                        baseFilter.push(BaseGroupType.UserAttribute);
                        break;
                    case "logins":
                        baseFilter.push(this.LoginBaseGroupLevel);
                        break;
                }
            });
        }

        if (this.multipleTypes)
            entityTypes = entityTypes.filter(e => baseFilter.findIndex(i => i == e.baseGroupType) > -1);

        // If item is selected filter out unselected to prevent multi-select
        //if ((filterOptions?.level?.length ?? 0) == 1)
        //    entityTypes = entityTypes.filter(e => filterOptions.level[0].id == `${e.baseGroupType}_${e.entityLevel}`);

        return entityTypes.map((e) => {
            return {
                id: `${e.baseGroupType}_${e.entityLevel}`,
                level: e.entityLevel.toString(),
                name: e.entityTypeName
            };
        });
    }

    private createColumnDefs(filterOptions: any = null): ColDef[] {
        if (!filterOptions)
            return [];

        let bulkAdd = this.options?.useBulkAdd ?? false;
        if (filterOptions.level?.length > 0)
            switch (filterOptions.level[0].id) {
                case "0_1":
                    return [{ headerCheckboxSelection: bulkAdd, checkboxSelection: bulkAdd, headerName: this.entityTypes.find(e => e.baseGroupType == BaseGroupType.Employee && e.entityLevel == 1)?.entityTypeName ?? "Agent", field: "entityName", flex: 1 }, { headerName: this.entityTypes.find(e => e.baseGroupType == BaseGroupType.Employee && e.entityLevel == 2)?.entityTypeName ?? "Team", field: "parentName", flex: 1 },{ headerName: "Company", field: "grandParentName", flex: 1 }];
                case "0_2":
                    return [{ headerCheckboxSelection: bulkAdd, checkboxSelection: bulkAdd, headerName: this.entityTypes.find(e => e.baseGroupType == BaseGroupType.Employee && e.entityLevel == 2)?.entityTypeName ?? "Team", field: "entityName", flex: 1 }, { headerName: this.entityTypes.find(e => e.baseGroupType == BaseGroupType.Employee && e.entityLevel == 3)?.entityTypeName ?? "Company", field: "parentName", flex: 1 }];
                case "0_3":
                    return [{ headerCheckboxSelection: bulkAdd, checkboxSelection: bulkAdd, headerName: this.entityTypes.find(e => e.baseGroupType == BaseGroupType.Employee && e.entityLevel == 4)?.entityTypeName ?? "Company", field: "entityName", flex: 1 }];
                case "1_1":
                    return [{ headerCheckboxSelection: bulkAdd, checkboxSelection: bulkAdd, headerName: this.entityTypes.find(e => e.baseGroupType == BaseGroupType.Recording && e.entityLevel == 1)?.entityTypeName ?? "Point of Contact", field: "entityName", flex: 1 }, { headerName: this.entityTypes.find(e => e.baseGroupType == BaseGroupType.Recording && e.entityLevel == 2)?.entityTypeName ?? "Skill", field: "parentName", flex: 1 }, { headerName: "Campaign", field: "grandParentName", flex: 1 }];
                case "1_2":
                    return [{ headerCheckboxSelection: bulkAdd, checkboxSelection: bulkAdd, headerName: this.entityTypes.find(e => e.baseGroupType == BaseGroupType.Recording && e.entityLevel == 2)?.entityTypeName ?? "Skill", field: "entityName", flex: 1 }, { headerName: this.entityTypes.find(e => e.baseGroupType == BaseGroupType.Recording && e.entityLevel == 3)?.entityTypeName ?? "Campaign", field: "parentName", flex: 1 }];
                case "1_3":
                    return [{ headerCheckboxSelection: bulkAdd, checkboxSelection: bulkAdd, headerName: this.entityTypes.find(e => e.baseGroupType == BaseGroupType.Recording && e.entityLevel == 3)?.entityTypeName ?? "Campaign", field: "entityName", flex: 1 }];
                case "1_4":
                    return [{ headerCheckboxSelection: bulkAdd, checkboxSelection: bulkAdd, headerName: this.entityTypes.find(e => e.baseGroupType == BaseGroupType.Recording && e.entityLevel == 4)?.entityTypeName ?? "Company", field: "entityName", flex: 1 }];
            }

        if (((this.multipleTypes && filterOptions.groups.findIndex(i => i.id == "logins") > -1) || (!this.multipleTypes && this.options.showTypeValues.logins))) // Logins
            return [{ headerName: this.localization.get("Logins") ?? "Logins", field: "entityName", flex: 1 }];
        else if (Number.parseInt(((filterOptions.level[0]?.id ?? "") as string).split('_')[0]) == 3) // Attributes
            return [{ headerName: this.localization.get("Attributes") ?? "Attributes", field: "entityName", flex: 1 }];

        return [];
    }

    public singleAssignValidation(): boolean {
        if (!this.options?.singleAssignValidation || !this.options?.singleAssignMessage) {
            return true;
        }

        const { filterOptionsChosen, selectedEntities, addedEntities } = this.entityComponent || {};

        if (!filterOptionsChosen?.level?.length || (!selectedEntities?.length && !addedEntities?.length)) {
            return true;
        }

        const filterLevelName = filterOptionsChosen.level[0].name;
        const selectedEntityName = selectedEntities?.[0]?.entityLevelName;
        const addedEntityName = addedEntities?.[0]?.entityLevelName;

        return !((selectedEntityName && filterLevelName !== selectedEntityName) || (addedEntityName && filterLevelName !== addedEntityName));
    }

    private createEntity(): Entity {
        return {
            assignedEntities: this.initialAssignment,
            newEntities: [],
            removedEntities: [],
            columnDefs: this.createColumnDefs(),
            dataset: this.entityList,
            filters: this.createFilters(),
            omnibar: {
                searchPlaceholderText: (this.options?.omniSearchPlaceHolder?.length > 0) ? this.options.omniSearchPlaceHolder
                    : this.localization?.get("Search_Text") ?? "Search..."
            },
            primaryColumnKey: 'entityName',
            searchFieldKey: 'entityName',
            selectedEntityTitleKey: 'entityName',
            noEntityAddedText: (this.options?.noneAssignedText?.length > 0) ? this.options.noneAssignedText
                : this.localization?.get('None_Assigned') ?? "None assigned",
            noEntitySelectedText: (this.options?.noneSelectedText?.length > 0) ? this.options.noneSelectedText
                : this.localization?.get('None_Selected') ?? "None selected",
            icon: undefined,
            onSearchQueryChanged: undefined,
            onFiltersChanged: this.onFilterChange.bind(this),
            disableInfiniteScroll: true,
            fetchData: () => { debugger; },
            useInfiniteScrollForAddedEntities: false,
            fetchAddedEntities: this.fetchAdded.bind(this),
            addedEntitiesQuery: '',
            enableBulkOperations: this.options?.useBulkAdd ?? false
        };
    }
    
    saveScrollPosition(container: HTMLElement) {
        this.scrollPosition = container.scrollTop;
    }

    restoreScrollPosition(container: HTMLElement, setNull: boolean = false) {
        container.scrollTop = this.scrollPosition;
        setTimeout(() => {
            this.scrollContainer.style.removeProperty('overflow');
        }, 1);
        
        if(setNull) {
            this.gridContainer = null;
        }
    }

    async fetchAdded(params: any) {
        this.entityComponent.addedEntities = [];
        this.entityComponent.applyFilter();
        return { totalRecords: 0, data: [] };
    }
}
